import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'lba-auth',
  styleUrls: ['./auth.component.scss'],
  templateUrl: './auth.component.html',
})

export class AuthComponent implements OnInit {

  constructor(private router: Router) {

  }

  ngOnInit() {
    this.router.navigate(['/auth/login']);
  }
}
